// node ./src/server/pyth/index

import Istore from "@/store"
const feeds = require("./evm_main.json")

const serviceConnection = require("@pythnetwork/pyth-evm-js")
const connection = new serviceConnection.EvmPriceServiceConnection (
    "https://hermes.pyth.network"
)

// xc弃用
// const serviceConnection = require("@pythnetwork/price-service-client")
// const connection = new serviceConnection.PriceServiceConnection(
//     "https://xc-mainnet.pyth.network"
// )

const methods = {

    getFunction() {
      return connection
    },
    // feeds中的商品信息是手功加上的 检查是否存在重复的键
    CheckRepeat() {
        let resArray=[]
        for (let i = 0; i < feeds.length; i++) {
            for (let i2 = 0; i2 < feeds.length; i2++) {
                if (feeds[i].symbol===feeds[i2].symbol && i!==i2) {
                    resArray.push('symbol: '+ feeds[i2].symbol)
                }
                if (feeds[i].CoinID===feeds[i2].CoinID && i!==i2) {
                    resArray.push('CoinID: '+ feeds[i2].CoinID)
                }
                if (feeds[i].id===feeds[i2].id && i!==i2) {
                    resArray.push('id: '+ feeds[i2].id)
                }
            }
        }
        return resArray
    },

    getSymbols() {
        let symbols = []
        for (let i = 0; i < feeds.length; i++) {
            symbols.push(feeds[i].symbol)
        }
        return symbols;
    },

    getFeedIds() {
        let resArrayIds = []
        for (let i=0; i<feeds.length; i++) {
            resArrayIds.push(feeds[i].id)
        }
        return resArrayIds
    },

    // 根据pyth feed ID取资产信息包括最新价
    getFeedByID(feedID) {
        for (let i=0; i<feeds.length; i++) {
            if (feeds[i].id === feedID) {
                return feeds[i]
            }
        }
    },

    // 根据系统CoinID取资产信息包括最新价
    getFeedByTokenID(TokenID) {
        for (let i = 0; i < feeds.length; i++) {
            if (feeds[i].CoinID === TokenID) {
                return feeds[i]
            }
        }
    },

    getFeedBySymbol(symbol) {
        let res = ''
        for (let i = 0; i < feeds.length; i++) {
            if (feeds[i].symbol === symbol) {
                res = feeds[i]
            }
        }
        return res
    },

    // 系统推送价格，emaPrice为均价，price为新价
    // 每次推送一个商品的价格 ids中价格格有更新的商品
    async getSubscribePriceFeedUpdates(ids) {
        console.log('ids', ids)
        // await connection.subscribePriceFeedUpdates(ids, (priceFeed) => {
        //     console.log('priceFeed',priceFeed)
        //     console.log('getPriceUnchecked',priceFeed.getPriceUnchecked())
        //     console.log('getPriceNoOlderThan',priceFeed.getPriceNoOlderThan(60))
        // });

        const getPriceFeedIds = await connection.getPriceFeedIds()
        console.log('getPriceFeedIds',getPriceFeedIds)

        const getp = await connection.getPriceFeedsUpdateData(ids)
        console.log('getp',getp)

        const LatestPrice = await connection.getLatestPriceFeeds(ids)
        console.log('last', LatestPrice)

    },

    // 取消订阅实时行情
    UnSubscribe() {
        const ids = this.getFeedIds()
        connection.unsubscribePriceFeedUpdates(ids)
            .then(()=>{
                console.log('UnSubscribe done')
                Istore.state.SubscribeTicker=false
            })
            .catch(error=>{
                console.log('UnSubscribe error', error)
            })
    },

    // 从预言机中订阅所有商品的实时行情价格存放在本地，需要用到实时价格的页面在从本地轮询取实时价格,
    // 在需要的页面启动订阅可供本面或其它页使用，在APP退出时注消订阅
    async setTickerPrice() {
        // 如果已订阅则退出不需要重复订阅
        if (Istore.state.SubscribeTicker) {
            console.log('already SubscribeTicker')
            return
        } else {
           Istore.state.SubscribeTicker = true
        }

        const ids = this.getFeedIds()
        // console.log('Subscribe ids', ids.length)
        // 订阅价格更新，当推送更新时修改前端价格
        await connection.subscribePriceFeedUpdates(ids, (priceFeed) => {
            // 更新界面的商品价格（横幅）
            for (let i=0; i< feeds.length;i++) {
                if (feeds[i].id === priceFeed.id) {
                    const price = priceFeed.price.price / (10 ** (priceFeed.price.expo * -1))
                    // 当价格小数位过多，超出小数位限制时需去除该商品或改用位移用字串显示小数
                    if (price.toString().indexOf('-')>0 || price.toString().indexOf('_')>0) {
                        console.log('subscribe price error feed:',i, feeds[i],'price meta:', priceFeed.price)
                    } else {
                        // console.log('sub price', price.toString())
                        feeds[i].price = price.toString()
                    }
                }
            }
        })
    },

    // ids = this.getIds()
    // 根据pyth feedID批量取最新价
    async price(idsArray) {
        let resPrice = []
        if (idsArray.length === 0) {
            console.log('not index id')
            return resPrice
        }
        const LatestPrice = await connection.getLatestPriceFeeds(idsArray)
        if (LatestPrice && LatestPrice.length > 0) {
            for (let i = 0; i < LatestPrice.length; i++) {
                const item = LatestPrice[i]
                const FeedInfo = this.getFeedByID(item.id)
                const priceFormat = item.price.price / (10 ** (item.price.expo * -1))
                // 当价格小数位过多，超出小数位限制时需去除该商品或改用位移用字串显示小数
                if (priceFormat.toString().indexOf('-')>0 || priceFormat.toString().indexOf('_')>0) {
                    console.log('price error feed:',i,'price meta:', item)
                } else {
                    resPrice.push([FeedInfo.CoinID, priceFormat.toString()])
                }

                // console.log('LatestPrice', i, FeedInfo.symbol, priceFormat, item.price.price, comm.formateTime(item.price.publishTime), item.price.publishTime, item.id)
            }
        }
        // console.log('LatestPrice2', resPrice)
        return resPrice
    }
}
export default {methods, feeds}
